// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    scroll-behavior: smooth;
}

body {
    margin: 0;
    color: var(--black-85);
    font-family: 'Inter', sans-serif;
    box-sizing: border-box;
    letter-spacing: 0.02em;

}

div {
    padding: 0;
    border: 0;
    margin: 0;

    text-overflow: clip;
    box-sizing: border-box;
    background-clip: border-box;
}

:focus-visible {
    outline: none;
}

::-webkit-scrollbar { 
    width: 7px;
    height: 7px;
}
::-webkit-scrollbar-thumb { 
    background: var(--black-25);
    border-radius: 5px;
}
::-webkit-scrollbar-thumb:hover {
    filter: brightness(1.2);
}
::-webkit-scrollbar-corner {
    background-color: #00000000;
}

:root {
    --black_10:#040608;
    --black-00:#101820;
    --black-02: #171F27;
    --black-03:#182027;
    --black-05:#1c242b;
    --black-07:#22282f;
    --black-10:#282f36;
    --black-15:#343b41;
    --black-20:#40464d;
    --black-25:#4c5258;
    --black-30:#575d62;
    --black-35:#64696e;
    --black-45:#7c8084;
    --black-65:#abaeb1;
    --black-80:#cdcdce;
    --black-85:#dbdcde;
    --black-90:#e7e8e9;
    --blue-1:#2c3a74;
    --blue-2:#5a6ccd;
    --hover-fg: var(--black-65);
    --hover-bg: var(--black-15);
    --red-1: #58292d;
    --red-2: #B72828;
    --red-3: #ec736a;
    --green-1: #49c97c;
    --dark-red: #28161c;
}

[data-sonner-toast] {
    transition: height 200ms ease, box-shadow 200ms ease, opacity 200ms ease;
}
.toast {
    font-size: 13px;
    text-align: left;
    display: flex;
    align-items: center;
    animation: toast-in 150ms ease;
}
@keyframes toast-in {
    from { opacity: 0.5; }
    to   { opacity: 1; }
}
.toast-icon {
    font-size: 16px;
    opacity: 0.6;
}
.toast-body {
    margin-left: 8px;
}
.toast-label {
    font-weight: 600;
}
.toast-verb {
    opacity: 0.6;
}
.toast-note {
    opacity: 0.4;
    font-size: 12px;
}
.toast-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
}
.toast-header-label {
    font-weight: 600;
    opacity: 0.5;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}
.toast-header-note {
    opacity: 0.4;
}
.toast-divider {
    border-bottom: 1px solid rgba(255,255,255,0.1);
    padding-bottom: 6px;
    margin-bottom: 6px;
}
.toast-row {
    display: flex;
    align-items: center;
}

.symbols {
    font-family: 'Material Symbols Outlined';
    user-select: none;
}

.mui-icons {
    font-family: 'Material Icons';
}

.acticon { 
    border-radius: 4px;
    font-size: 24px;

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    user-select: none; 
}

.acticon:hover {
    filter: brightness(1.4);
}

.tridot {
    font-size: 28px;
    width: 24px;
    line-height: 0.95;
    cursor: pointer;
    user-select: none; 
    font-family: 'Material Symbols Outlined';
}

.tridot:hover {
    filter: brightness(1.3);
}

#wolfflogo {
    position: absolute;
    top: 16px;
    left: 20px;
}

#session {
    width: 200px;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
}

#friendly {
    width: 180px;
    height: 100%;
    margin-right: 16px;

    font-size: 15px;
    border-radius: 4px;

    background-color: var(--black-10);

    display: flex;
    text-align: left;
    align-items: center;
}

#friendly.undefined {
    background-color: var(--red-2);

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

#friendly.undefined.connected {
    background-color: var(--green-1);
}

#friendly .name {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 75%, transparent 100%);
}

#friendly.defined .name {
    padding-left: 10px;
}

#friendly.defined .name::before {
    font-family: 'Material Icons';
    font-size: 13px;
    color: var(--red-2);
    content: 'circle';
    padding-right: 6px;
}

#friendly.defined.connected .name::before {
    color: var(--green-1);
}

#friendly .name.edit {
    background-color: var(--black_10);
    color: var(--black-90);
    border: var(--black-90) solid 1px;
    border-radius: 4px;
    text-overflow: clip;
}

#chain-new,
#device-new {
    margin-left: 26px;
}

#device-new {
    background-color: green;
}

#chain-new .symbol,
#device-new .symbol {
    font-size: 20px;
}

.symbol {
    display: inline;
    font-family: 'Material Symbols Outlined';
    font-weight: 800;
}

#top-icons {
    margin-left: 180px;
    margin-top: 20px;
    height: 32px;
    max-height: 32px;
    display: flex;
    justify-content:space-between;
    align-items: center;
}

.top.cta {
    padding: 10px;
    height: 100%;
}

#top-left, #top-right {
    height: 32px;
    max-height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
}

#top-right {
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content:space-between;
}

/* Zoom hint placed between left and right clusters */
#zoom-hint {
    margin-left: 12px;
    margin-right: auto; /* pull block toward the left cluster */
    font-size: 13px;
    color: var(--black-80);
    opacity: 0.9;    
    pointer-events: none;
    min-width: 0; /* allow flex shrink/ellipsis */
}

#midi-over {
    display: none;
    position: absolute;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0,0,0,0.5);
    z-index: 1;
    backdrop-filter: blur(0.8px);
}

#midi {
    font-size: 18px;
    padding-right: 12px;
    margin-right: 20px;
    position: relative;
    pointer-events: none;
    filter: brightness(0.7);
}

#midi.enabled {
    filter: brightness(1);
    pointer-events: all;
}

#midi.enabled.selected {
    filter: brightness(1.1);
    outline: 2px solid var(--black-80);
    z-index: 2;
}

#midi.midi-bad {
    font-style: italic;
    color: var(--black-65);
}

.midi-ports .port {
    color: var(--black-65);
}

.midi-ports .port.selected {
    color: var(--black-80);
}

.midi-ports .port.bad {
    font-style: italic;
    color: var(--black-45);
}

.midi-learn {
    z-index: 2;
    pointer-events: all;
}

.midi-learn.learning {
    animation: pulse-fg 0.3s ease-in-out infinite;
}

@keyframes pulse-fg {
    0%, 100% {
        outline-width: 0.1px;
        outline-color: rgba(147, 55, 255, 0);
        filter: brightness(0.8);
    }
    50% {
        outline-width: 3px;
        outline-color: rgba(147, 55, 255, 0.5);
        filter: brightness(1);
    }
}

.midi-learn::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 120cqw;
    height: 120cqh;
    background: rgb(147, 55, 255);
    transform: translate(-50%, -50%);
    animation: pulse-bg 1.5s ease-in-out infinite;
    z-index: 2;
}

.midi-learn.learning::after {
    animation: pulse-bg 0.3s ease-in-out infinite;
}

@keyframes pulse-bg {
    0%, 100% {
        opacity: 0;
    }
    50% {
        opacity: 0.65;
    }
}

#mute-all .symbol {
    font-size: 20px;
}

#mute-all {
    position: relative;
    height: 32px;
    width: 100px;
    font-size: 18px;
    background-color: var(--red-1);
    margin-right: 20px;
}

#mute-all:hover {
    background-color: var(--red-2);
}

#system-help {
    width: 48px;
    font-size: 26px;
}

#system-help a {
    text-decoration: none;
    color: var(--black-85);
}

#system-menu {
    padding-right: 4px;
    height: 32px;
    width: 23px;
    box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);

    border-radius: 4px;

    background: var(--black-02);

    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1.3;

    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    overflow: hidden;
}

#system-menu.update .tridot {
    animation: system-menu 600s ease-in-out infinite;
}

@keyframes system-menu {
    0%,0.25%,0.5% { transform: scale(1); }
    0.125%,0.375% { transform: scale(1.4); }
}

#system-menu:hover {
    filter: brightness(0.8);
}

#system-menu:hover .tridot {
    filter: brightness(0.8);
}

#system-menu.update {
    width: 100px;
    justify-content: right;
    background-color: var(--blue-1);
}

#system-menu.update .text {
    font-size: 17px;
}

/* soft, sweeping highlight */
.shimmer {
    position: relative;
    overflow: hidden;
    background-color: #1F2937;
    color: #D1D5DB;
}

.shimmer::before {
    content: '';
    position: absolute;
    top: 0;
    left: -120%; /* Start off-screen */
    width: 50%;
    height: 100%;
    background: linear-gradient(
        90deg,
        transparent,
        rgba(255, 255, 255, 0.14), /* faint white highlight */
        transparent
    );
    transform: skewX(-25deg); /* Skews the light source for a more dynamic look */
    animation: shimmer 600s ease-in-out infinite;
}

@keyframes shimmer {
    0%,1%,2%,100% { left: -120%; }
    0.5%,1.5% { left: 120%; }
}

#space {
    position: fixed;
    top: 70px;
    left: 380px;
    height: calc(100vh - 72px - 5px);
    width: calc(100vw - 360px - 30px);
    overflow: hidden;
}

/* User background image layer — sits behind all chain content, never the
   sidebar (it lives inside #space, which already starts past the browser).
   Driven by --space-bg-* custom properties set on #space from app settings. */
.space-bg {
    position: absolute;
    inset: 0;
    z-index: 0;                       /* painted before later, auto-z chain content */
    pointer-events: none;
    background-image: var(--space-bg-image, none);
    background-size: var(--space-bg-size, cover);
    background-repeat: var(--space-bg-repeat, no-repeat);
    background-position: var(--space-bg-pos, center);
    opacity: var(--space-bg-opacity, 1);
    filter: blur(var(--space-bg-blur, 0px));
}

/* Dim scrim above the image so busy photos don't drown the UI */
.space-bg::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, var(--space-bg-dim, 0));
}

#space.midi-learning {
    z-index: 1;
}

.menu {
    position: absolute;
    z-index: 100;
    border-radius: 2px;
    background: var(--black-07);
    padding: 6px 6px 6px 6px;
    width: 160px;
}
  
.menu .item  {
    position: relative;
    height: 32px;
    padding-left: 10px;
    color: var(--black-80);
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 160px;
}

.menu .item.submenu {
    height: 38px;
    padding-top: 4px;
}
  
.menu .item.divider {
    border-top: 1px solid var(--black-30);
}

.menu .item:hover {
    color: var(--black-90);
    background: var(--hover-bg);
}

.menu .item.submenu::after {
    content: '>';
    position: absolute;
    right: 10px;
    font-size: 16px;
    color: var(--black-90);
}

.menu .item .submenu  {
    display: none;
    position: absolute;
    z-index: 100;
    top: 0px;
    left: -174px;
    border-radius: 4px;
    background: var(--black-07);
    padding: 3px 8px 6px 8px;
}

.menu .item .submenu .item .submenu  {
    display: none;
    position: absolute;
    z-index: 100;
    top: 0px;
    left: -100px;
    border-radius: 4px;
    background: var(--black-07);
    padding: 3px 8px 6px 8px;
}

.menu .item:hover .submenu  {
    display: block;
}

.menu .item .submenu .item:hover .submenu   {
    display: block;
}

.menu .submenu .item {
    color: var(--black-65);
}

.menu .submenu .item:hover {
    color: var(--black-90);
}

.menu .item .choice  {
    padding-right: 8px;
}

.menu .item .owner {
    color: var(--black-45);
}

.menu .item.hilite .choice {
    color: var(--black-90);
}

.hidden { display: none; }

#ingest-errors {
    position: fixed;
    z-index: 999;
    width: 90vw;
    height: 50vh;
    top: 25vh;
    height: 50vh;
    left: 5vw;
    border-radius: 5px;
    background: white;
    color: black;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  }
  
  #ingest-errors pre {
    padding-left: 10px;
    height: 40vh;
    font-size: 17px;
    color: black;
    overflow: scroll;
  }
  
  #ingest-errors button {
    display: flex;
    color: black;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    width: 80px;
  }

#screen {
    height: 100vh;
    width: 100vw;
    min-width: 1036px;
    background: var(--black-00);
    position: relative;
    overflow: hidden;
}

#screen.disconnected {
    background: var(--dark-red);
}
  
.midi-channel.selected .reserved {
    padding-left: 10px;
    opacity: 60%;
    width: 100%;
}

.note.selected .reserved {
    padding-left: 10px;
    color: var(--black-80);
    width: 100%;
}

.browser-device {
    position: relative;
    width: 325px;
    height: 40px;
    display: flex;
    background-color: var(--black-15);
    align-items: center;
    color: var(--black-80);
    border: 1px solid #00000000;
}

.browser-device:hover {
    color: var(--black-90);
    border-color: var(--black-35);
}

.browser-device.selected {
    border-color: var(--black-45);
}

.browser-device .name {
    position: absolute;
    left: 10px;
    width: 100%;

    font-size: 15px;
    font-weight: 500;

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 75%, transparent 100%);
}

.browser-device.selected .name {
    color: var(--black-90);
    font-weight: bold;
}

.browser-device .popup {
    position: absolute;
    top: 8px;
    right: 1%;

    font-size: 24px;
}

.browser-module {
    border-radius: 2px;
    position: relative;
    height: 40px;
    width: 328px;

    display: flex;
    background-color: var(--black-15);

    align-items: center;
}

.browser-module.invalid {
    background: var(--red-1);
}

.browser-module .popup {
    font-size: 24px;
    position: absolute;
    top: 8px;
    right: 3px;
}

.popup-menu .menu-list .menu-item.octave {
    display: block; 
    text-align: right; 
}

.browser-module.submodule {
    background-color: var(--black-10);
}

.browser-module .expander {
    position: absolute;
    right: 83px;
    width: 18px;

    color: var(--black-65);

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    user-select: none; 
}

.browser-module.invalid .expander {
    color: var(--black-45);
}

.browser-module .device  {
    position: relative;
    left: 12px;
    top: -8px;
    width: 260px;

    font-size: 14px;
    color: var(--black-90);

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 80%, transparent 100%);
}

.browser-module.invalid .device  {
    color: var(--black-45);
    font-style: italic;
}

.browser-module.stereo .device {
    width: 210px;
}

.browser-module.m2s .device  {
    width: 230px;
}

.browser-module .name {
    position: absolute;
    bottom: 3px;
    left: 12px;
    width: 260px;

    font-size: 12px;
    color: var(--black-65);

    white-space: nowrap;
    overflow: hidden;
    mask: linear-gradient(to right, black 80%, transparent 100%);
}

.browser-module.invalid .name {
    color: var(--black-45);
    font-style: italic;
}

.browser-module.stereo .name {
    width: 210px;
}

.browser-module.m2s .name {
    width: 240px;
}

.browser-module .channels {
    position: absolute;
    right: 24px;
    height: 100%;

    font-size: 11px;

    white-space: nowrap;
    text-overflow: clip;

    text-align: center;
    display: flex;
    justify-content: right;
    align-items: center;
}

.browser-module .channels .channel {
    height: 26px;
    width: 26px;

    font-weight: normal;

    border-radius: 26px;
    color: var(--black-80);
    background-color: var(--black-25);

    box-shadow: 0 0 1px var(--black-05);

    font-size: 13px;

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.browser-module.invalid .channels .channel {
    color: var(--black-45);
}

.browser-module .channels .channel.used {
    color: var(--black-05);
    font-weight: 500;
}

.browser-module .channels .channel.m2s {
    position: relative;
    width: 42px;
    font-size: 12.5px;
}

.browser-module .channels .channel.stereo.L {
    margin-right: 3px;
}

/* DOUBLE-CLICK an L/R chip to add just that channel */
.browser-module .channels .channel.choosable {
    cursor: pointer;
}

.browser-module .inuse {
    position: absolute;
    left: 306px;
    width: 51px;
    height: 24px;
    font-size: 0px;

    display: flex;

    text-align: center;
    justify-content: center;
    align-items: center;

    visibility: hidden;
}

.browser-module.used .inuse {
    font-size: 13px;
    font-weight: bold;

    visibility:visible;
}

.browser-module .popup {
    font-size: 22px;
    color: var(--black-65);
}

#browser-main {
    width: 360px;
    align-content: start;
    top: 70px;
    position: absolute;
    left:20px;
    background-color: var(--black-05);
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    height: 42px;
    overflow-x: visible;
}

#browser-main .types {
    padding-top: 12px;

    color: var(--black-45);

    display:flex;
    gap: 32px;
    text-align: center;
    justify-content: center;
    align-items: center;
}

#browser-main .types .choice .svgicon {
    display:flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding-right: 4px;
}

#browser-main .types .choice {
    font-size: 16px;
    font-weight: 500;

    cursor: pointer;
    user-select: none; 

    display:flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

#browser-main .types .choice .symbols {
    font-size: 20px;
    padding-right: 3px;
    vertical-align: middle;
}

#browser-main .types .choice:hover {
    color: var(--black-80);
}

#browser-main .types .choice.selected {
    color: var(--black-85);
}

#browser-main .types .choice .svgicon .fill {
    fill: var(--black-45);
}

#browser-main .types .choice:hover .svgicon .fill {
    fill: var(--black-80);
}

#browser-main .types .choice.selected .svgicon .fill  {
    fill: var(--black-85);
}

#browser {
    width: 360px;
    align-content: start;
    top: 112px;
    position: absolute;
    left:20px;
    background-color: var(--black-05);
    height: calc(100vh - 116px - 5px);
    overflow-x: visible;
}

.browser {
    position: relative;
    display:flex;
    flex-direction: column;
    background-color: var(--black-30);
    align-items: center;
    overflow: visible;
}

.browser .search-hr {
    width: 328px;
    height: 1px;
    margin-bottom: 14px;
}

.browser .tag-hr {
    width: 328px;
    height: 1px;
    background-color: var(--black-25);
    margin-top: 8px;
    margin-bottom: 8px;
}

.browser .search .icon {
    position: absolute;
    top: 6px;
    left: 26px;
    font-size: 22px;
    color: var(--black-45);
    user-select: none; 
}

.browser .searchbox {
    margin-top: 4px;
    font-size: 15px;
  
    width: 328px;
    height: 32px;
    /** if missing, caret appears in upper left of searchbox when empty (and focused) */
    padding: 5px;
    padding-left: 38px;

    color: var(--black-65);
    background-color: var(--black-10);

    border: solid var(--black-15) 1px;
    border-radius: 4px;

    /** prevents default outlining of active input text box */
    outline: none;

    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    overflow: hidden;
}

.browser .searchbox.hidden {
    display: none;
}
  
.browser .searchbox.empty {
    color: var(--black-35);
    user-select: none; 
}

.browser .searchbox.edit {
    font-style: normal;
    text-overflow: clip;
    overflow: hidden;
    color: var(--black-80);
    background-color: var(--black-20);
}

.browser.module .types {
    color: var(--black-45);

    margin-top: 14px;
    margin-bottom: 0px;

    height: 100%;
    max-height: 24px;

    display: flex;
    align-items: center;
    gap: 18px;
}

.browser .types .choice {
    font-size: 15px;
    letter-spacing: 0;

    cursor: pointer;
    user-select: none; 

    display:flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

.browser .types .choice:hover {
    color: var(--black-80);
}

.browser .types .choice.selected {
    color: var(--black-85);
}

.browser .types .choice .svgicon {
    display:flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

.browser .types .choice .svgicon .fill {
    fill: var(--black-45);
}

.browser .types .choice:hover .svgicon .fill {
    fill: var(--black-80);
}

.browser .types .choice.selected .svgicon .fill  {
    fill: var(--black-85);
}

.browser .filters {
    width: 336px;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 15px;
    margin-bottom: 4px;
}

.browser .tags .tag:not(.selected):hover {
    color: var(--black-03);
    background-color: var(--black-45);
}

.browser .header .type {
    position: absolute;
    left: 5px;

    font-size: 18px;
    font-weight: bold;
    color: var(--black-85);

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;

    user-select: none; 
}

.browser .header .sort,
.browser .header .active {
    width: 75px;
    height: 22px;
    border-radius: 4px;

    font-size: 13px;
    font-weight: bold;

    padding-left: 12px;
    padding-right: 10px;

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    user-select: none; 

    color: var(--black-05);
    background-color: var(--black-80);
}

.browser .header .sort:hover,
.browser .header .active:hover {
    color: var(--black-05);
    background-color: var(--black-65);
}

.browser .header {
    width: 320px;
    margin-bottom: 8px;

    font-size: 22px;

    display: flex;
    text-align: center;
    justify-content:space-between;
    align-items: center;
}

.browser .header > .left {
    display: flex;
    text-align: center;
    justify-content: left;
    align-items: center
}

.browser .header > .right {
    display: flex;
    text-align: center;
    justify-content: left;
    align-items: center;
}

.chain.browser .header .fave {
    margin-left: 10px;
    height: 22px;
    color: var(--black-35);
}

.chain.browser .header .fave.selected {
    color: var(--black-80);
}

.chain.browser .header .fave:hover {
    color: var(--black-65);
}

.chain.browser .header .normal {
    font-size: 23px;
    height: 22px;
    margin-left: 13px;
    color: var(--black-35);
}

.chain.browser .header .normal.selected {
    color: var(--black-80);
    font-weight: bold;
}

.chain.browser .header .normal:hover {
    color: var(--black-65);
}

.browser .results {
    position: relative;
    flex-grow: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    width: 332px;
    margin-left: 10px;
}

.browser .results .items {
    width: 340px;
}

.browser .results .items .item {
    min-height: 43px;
    padding: 1px;
}

.browser.device .results .items .item:nth-child(odd) .browser-device {
    background-color: var(--black-20);
}

.browser .results .items .item .subitem  {
    min-height: 42px;
    display: none;
}

.browser .results .items .item .subitem.expanded {
    display: block;
}

.browser .results .items .item .subitem.expanded.top {
    margin-top: 2px;
}

.browser .results .items .empty {
    height: 42px;
    padding-right: 40px;

    font-size: 14px;
    font-style: italic;
    color: var(--black-45);

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;

    user-select: none; 
}

.browser.device > .cta.new {
    left: 21px;
}

#controls {
    display: flex;
    gap: 14px;
    top: 10px;
    position: absolute;
    left:506px;
}

.cta {
    height: 32px;
    padding-left: 16px;
    padding-right: 16px;
    border-radius:4px;
    background-color: var(--blue-1);

    box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);

    font-size: 14px;
    font-weight: 500;
    color: var(--black-80);

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    user-select: none; 

    white-space: nowrap;
    overflow: hidden;
}

.cta:hover {
    color: var(--black-65);
}

.cta.secondary {
    color: var(--blue-2);
    outline: 1px solid var(--blue-2);
    outline-offset: -1px;
    background-color: transparent;
}

.cta.secondary:hover {
    color: var(--black-65);
}

.modal.modtype .options {
    display: flex;
    gap: 22px;
    justify-content: space-around;
    padding-left: 22px;
    padding-right: 22px;
    padding-top: 20px;
}

.modal.modtype .options .option {
    font-size: 48px;
    height: 130px;
    padding-left: 20px;
    padding-right: 20px;
    border-radius: 4px;
    background-color: var(--black-15);

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    cursor: pointer;
    user-select: none; 
}

.popup {
    user-select: none; 
    cursor: pointer;
}

.popup-menu {
    visibility: hidden;
    position: absolute;
    border: 1px solid #333;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
    transition: opacity 0.2s ease-in-out;
    background-color: #00000000;
}

.popup-menu:hover {
    display: block;
}
  
.menu-list,
.submenu-list {
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    list-style: none;
    margin-top: 5px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-left: 5px;
    padding-right: 5px;
    background-color: var(--black-00);
    border: 1px solid var(--black-10);
}

.menu-item {
    position: relative;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 7px;
    padding-bottom: 7px;

    color: var(--black-80);
    font-weight: 500;

    cursor: pointer;
    user-select: none;;
    white-space: nowrap;

    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* invisible hover zones extending from parent menu items */
.menu-item.cascade::before {
    content: '';
    position: absolute;
    top: -8px;
    bottom: -8px;
    left: -8px;
    right: -15px; /* Extend further right toward submenu */
    z-index: -1;
    pointer-events: auto;
  }

  .submenu-list::before {
    content: '';
    position: absolute;
    top: -8px;
    bottom: -8px;
    left: -15px; /* Connect back to parent menu */
    right: -8px;
    z-index: -1;
    pointer-events: auto;
  }

  /* Increase hit area for cascade items */
  .submenu-list {
    padding-left: 5px;
    padding-right: 4px;
  }

  /* Create invisible connection between submenu and parent */
.menu-list::after,
  .submenu-list::after {
    content: '';
    position: absolute;
    top: -20px;
    bottom: 0;
    left: -10px; /* Invisible bridge from parent */
    width: 20px;
    pointer-events: auto;
    z-index: 1;
  }

.menu-item.midi {
    justify-content: left;
    padding-top: 6px;
    padding-bottom: 6px;
    color: var(--black-65);
}

.menu-item.midi .svgicon {
    padding-top: 4px;
}

.menu-item.disabled {
    color: var(--black-45);
    font-weight: normal;
}
  
.menu-item.shimmer {
    background-color: var(--black-10);
    border-radius: 4px;
    color: #7db4f0;
}

.menu-item.active:hover {
    background: var(--black-20);
}

.menu-item.cascade:hover {
    background: var(--black-20);
}

.menu-item.div-top {
    border-top: 1px solid var(--black-30);
}

.menu-item.div-bottom {
    border-bottom: 1px solid var(--black-30);
}
  
.menu-item:has(+ .div-top) {
    padding-top: 10px;
    padding-bottom: 11px;
}

.menu-item.cascade::after {
    position: relative;
    right: -4px;
    font-family: 'Material Symbols Outlined';
    font-size: 11px;
    font-weight: bold;
    content: "arrow_forward_ios";
    margin-right: 0px;
    color: var(--black-90);
}

.menu-item.cascade.empty::after {
    color: var(--black-45);
}

.menu-item.cascade.disabled::after {
    color: var(--black-45);
}

.menu-item.cascade.empty {
    color: var(--black-45);
}

.submenu-list {
    position: absolute;
    visibility: hidden;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);
    margin-left: 5px;
    z-index: 1000;
}
  
.menu-item:hover > .submenu-list {
    min-width: 40px;
    visibility: visible;
}

.newmod .name.editbox {
    font-size: 18px;
    height: 28px
}

.modal .newmod .prompt {
    color: var(--black-65);
    font-size: 20px;
}

.modal .newmod .header {
    font-size: 16px;
    color: var(--black-65);
}

.modal .newmod .options {
    padding: 10px;
    background-color: var(--black-05);
}

.modal .newmod .option.selected {
    background-color: var(--black-15);
    color: var(--black-90);
}

.modal .newmod .cta.disabled {
    background-color: var(--black-15);
    color: var(--black-30);
}

.modal .newmod .option.disabled{
    color: var(--black-35);
}

.modal .newmod .option:hover {
    background-color: var(--black-25);
}

.midi-event {
    z-index: 10;
    border-radius: 32px;
    visibility: hidden;
    border: 5px solid var(--black-45);

    font-weight: 500;
    color: var(--black-80);

    background-color: rgb(0 0 0 / 0.6);

    position: absolute;
    width: 250px;
    height: 250px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    animation: fadeOut 1.2s ease-in;

    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
    align-items: center;

    pointer-events: none;
}

.midi-event .note {
    font-size: 100px;
    height: 100px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

.midi-event .channel {
    font-size: 38px;
    height: 40px;

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

.midi-event .state {
    font-size: 42px;
    height: 60px;

    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
}

.midi-event .ts {
    font-size: 8px;
    color: var(--black-45);
}

.midi-event::after {
    position: absolute;
    font-weight: normal;
    opacity: 0.3;
    font-family: 'Material Icons';
    font-size: 250px;
    content: 'music_note';
    color: var(--black-65);
}

@keyframes fadeOut {
    from { 
      visibility: visible; 
      opacity: 0.9;
    }
    to { 
      visibility: hidden; 
      opacity: 0; 
    }
}  

#time-display {
    z-index: 999;
    font-size: 14px;
    color: #444;
    position: fixed;
    background-color: #00000000;
    user-select: none;    
    left: 18px;
    top: 55px;
}


/* On narrower screens, show hint on its own top row */
@media (max-width: 1200px) {
    #top-icons { height: auto; max-height: none; flex-wrap: wrap; align-items: flex-start; }
    #zoom-hint {
        order: -1;
        flex: 0 0 100%;
        margin: 0 0 8px 0;
        padding: 4px 0;
        text-align: center;
        background: var(--dark-red);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        border-radius: 4px;
    } 
    #browser-main {top: 100px}
    #browser {top: 140px}
    #space {top: 100px}
    #time-display {
        width: 155px;
    }
}

/* ── NODE PICKER (right-click replace) ── */
.node-picker {
    width: 280px;
    max-height: 60vh;
    display: flex;
    flex-direction: column;
    background-color: var(--black-00);
    border: 1px solid var(--black-15);
    border-radius: 6px;
    box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.4);
    overflow: hidden;
}

.node-picker .np-filter {
    flex: 0 0 auto;
    margin: 6px;
    padding: 7px 9px;
    font-size: 13px;
    color: var(--black-90);
    background-color: var(--black-10);
    border: 1px solid var(--black-20);
    border-radius: 4px;
    outline: none;
}

.node-picker .np-filter:focus {
    border-color: #4a90d9;
}

.node-picker .np-tags {
    flex: 0 0 auto;
    padding: 2px 8px 8px;
    max-height: 96px;
    overflow-y: auto;
    border-bottom: 1px solid var(--black-10);
}

.node-picker .np-tags .tag {
    cursor: pointer;
    height: 20px;
}

.node-picker .np-list {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: 0 6px 6px;
}

.node-picker .np-section {
    font-size: 10px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--black-45);
    padding: 6px 4px 2px;
}

/* CURRENT slot occupant, pinned at the top and bracketed by two divider lines */
.node-picker .np-pinned {
    border-top: 1px solid var(--black-20);
    border-bottom: 1px solid var(--black-20);
    margin-bottom: 4px;
}

.node-picker .np-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
}

.node-picker .np-row:hover {
    background-color: var(--black-10);
}

.node-picker .np-row .device {
    flex: 1 1 auto;
    font-size: 13px;
    color: var(--black-90);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.node-picker .np-row .name {
    flex: 0 0 auto;
    font-size: 11px;
    color: var(--black-60);
    white-space: nowrap;
}

/* CHANNEL circles — scaled-down version of .browser-module .channels .channel */
.node-picker .np-row .channels {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: right;
}

.node-picker .np-row .channels .channel {
    height: 18px;
    width: 18px;
    border-radius: 18px;
    background-color: var(--black-25);
    color: var(--black-80);
    box-shadow: 0 0 1px var(--black-05);
    font-size: 9.5px;
    font-weight: normal;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.node-picker .np-row .channels .channel.used {
    color: var(--black-05);
    font-weight: 500;
}

.node-picker .np-row .channels .channel.m2s {
    width: 29px;
    font-size: 9px;
}

.node-picker .np-row .channels .channel.stereo.L {
    margin-right: 2px;
}

.node-picker .np-row.current .device::before {
    content: '\\25CF\\00a0';
    color: var(--black-50);
}

.node-picker .np-empty {
    padding: 12px;
    text-align: center;
    color: var(--black-45);
    font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAIA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,gCAAgC;IAChC,sBAAsB;IACtB,sBAAsB;;AAE1B;;AAEA;IACI,UAAU;IACV,SAAS;IACT,SAAS;;IAET,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;AACA;IACI,2BAA2B;IAC3B,kBAAkB;AACtB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,wEAAwE;AAC5E;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,OAAO,YAAY,EAAE;IACrB,OAAO,UAAU,EAAE;AACvB;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;AACA;IACI,8CAA8C;IAC9C,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,eAAe;;IAEf,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,wCAAwC;AAC5C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;;IAElB,eAAe;IACf,kBAAkB;;IAElB,iCAAiC;;IAEjC,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;;IAE9B,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA,qDAAqD;AACrD;IACI,iBAAiB;IACjB,kBAAkB,EAAE,uCAAuC;IAC3D,eAAe;IACf,sBAAsB;IACtB,YAAY;IACZ,oBAAoB;IACpB,YAAY,EAAE,+BAA+B;AACjD;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,iCAAiC;IACjC,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI;QACI,oBAAoB;QACpB,oCAAoC;QACpC,uBAAuB;IAC3B;IACA;QACI,kBAAkB;QAClB,sCAAsC;QACtC,qBAAqB;IACzB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,cAAc;IACd,6BAA6B;IAC7B,gCAAgC;IAChC,6CAA6C;IAC7C,UAAU;AACd;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,0CAA0C;;IAE1C,kBAAkB;;IAElB,2BAA2B;;IAE3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;;IAEhB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,gBAAgB,mBAAmB,EAAE;IACrC,gBAAgB,qBAAqB,EAAE;AAC3C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW,EAAE,qBAAqB;IAClC,UAAU;IACV,YAAY;IACZ;;;;;KAKC;IACD,wBAAwB,EAAE,mDAAmD;IAC7E,4CAA4C;AAChD;;AAEA;IACI,gBAAgB,WAAW,EAAE;IAC7B,YAAY,UAAU,EAAE;AAC5B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,gCAAgC;IAChC,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;;8EAE8E;AAC9E;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU,wBAAwB,+CAA+C;IACjF,oBAAoB;IACpB,6CAA6C;IAC7C,4CAA4C;IAC5C,oDAAoD;IACpD,gDAAgD;IAChD,mCAAmC;IACnC,uCAAuC;AAC3C;;AAEA,gEAAgE;AAChE;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,iDAAiD;AACrD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,UAAU,aAAa,EAAE;;AAEzB;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;EACb;;AAEF;IACI,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,iCAAiC;IACjC,mBAAmB;IACnB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;;IAEX,eAAe;IACf,gBAAgB;;IAEhB,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;;IAET,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;;IAEZ,aAAa;IACb,iCAAiC;;IAEjC,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;;IAEX,sBAAsB;;IAEtB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,YAAY;;IAEZ,eAAe;IACf,sBAAsB;;IAEtB,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;;IAEZ,eAAe;IACf,sBAAsB;;IAEtB,mBAAmB;IACnB,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;;IAEZ,eAAe;;IAEf,mBAAmB;IACnB,mBAAmB;;IAEnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;;IAEX,mBAAmB;;IAEnB,mBAAmB;IACnB,sBAAsB;IACtB,iCAAiC;;IAEjC,mCAAmC;;IAEnC,eAAe;;IAEf,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,sDAAsD;AACtD;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,cAAc;;IAEd,aAAa;;IAEb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;;IAEjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,iCAAiC;IACjC,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;;IAEjB,sBAAsB;;IAEtB,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;;IAEhB,eAAe;IACf,iBAAiB;;IAEjB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,iCAAiC;IACjC,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,iCAAiC;IACjC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,iCAAiC;IACjC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;;IAEf,YAAY;IACZ,YAAY;IACZ,mFAAmF;IACnF,YAAY;IACZ,kBAAkB;;IAElB,sBAAsB;IACtB,iCAAiC;;IAEjC,iCAAiC;IACjC,kBAAkB;;IAElB,yDAAyD;IACzD,aAAa;;IAEb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,sBAAsB;;IAEtB,gBAAgB;IAChB,kBAAkB;;IAElB,YAAY;IACZ,gBAAgB;;IAEhB,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;;IAEjB,eAAe;IACf,iBAAiB;;IAEjB,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,SAAS;;IAET,eAAe;IACf,iBAAiB;IACjB,sBAAsB;;IAEtB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,kBAAkB;;IAElB,eAAe;IACf,iBAAiB;;IAEjB,kBAAkB;IAClB,mBAAmB;;IAEnB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;IACf,iBAAiB;;IAEjB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,YAAY;IACZ,kBAAkB;;IAElB,eAAe;;IAEf,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;;IAEnB,eAAe;IACf,kBAAkB;IAClB,sBAAsB;;IAEtB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,SAAS;IACT,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;;IAE/B,0CAA0C;;IAE1C,eAAe;IACf,gBAAgB;IAChB,sBAAsB;;IAEtB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;IACf,iBAAiB;;IAEjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;IAChC,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;;IAEjC,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,0CAA0C;IAC1C,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;;IAEnB,sBAAsB;IACtB,gBAAgB;;IAEhB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;;IAEnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,2DAA2D;AAC3D;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,UAAU;IACV,YAAY,EAAE,wCAAwC;IACtD,WAAW;IACX,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW,EAAE,gCAAgC;IAC7C,WAAW;IACX,WAAW;IACX,oBAAoB;EACtB;;EAEA,wCAAwC;EACxC;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,2DAA2D;AAC7D;;IAEI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW,EAAE,iCAAiC;IAC9C,WAAW;IACX,oBAAoB;IACpB,UAAU;EACZ;;AAEF;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,wCAAwC;IACxC,eAAe;IACf,iBAAiB;IACjB,4BAA4B;IAC5B,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;;IAEjC,gBAAgB;IAChB,sBAAsB;;IAEtB,kCAAkC;;IAElC,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,SAAS;IACT,gCAAgC;;IAEhC,+BAA+B;;IAE/B,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;;IAEnB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;;IAEZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;;IAEZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI;MACE,mBAAmB;MACnB,YAAY;IACd;IACA;MACE,kBAAkB;MAClB,UAAU;IACZ;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,UAAU;IACV,SAAS;AACb;;;AAGA,sDAAsD;AACtD;IACI,aAAa,YAAY,EAAE,gBAAgB,EAAE,eAAe,EAAE,uBAAuB,EAAE;IACvF;QACI,SAAS;QACT,cAAc;QACd,iBAAiB;QACjB,cAAc;QACd,kBAAkB;QAClB,2BAA2B;QAC3B,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;QACvB,kBAAkB;IACtB;IACA,eAAe,UAAU;IACzB,UAAU,UAAU;IACpB,QAAQ,UAAU;IAClB;QACI,YAAY;IAChB;AACJ;;AAEA,4CAA4C;AAC5C;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,iCAAiC;IACjC,iCAAiC;IACjC,kBAAkB;IAClB,2CAA2C;IAC3C,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,iCAAiC;IACjC,iCAAiC;IACjC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA,gFAAgF;AAChF;IACI,qCAAqC;IACrC,wCAAwC;IACxC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,gFAAgF;AAChF;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,iCAAiC;IACjC,sBAAsB;IACtB,mCAAmC;IACnC,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined');\n@import url('https://fonts.googleapis.com/icon?family=Material+Icons');\n@import url('https://fonts.googleapis.com/css2?family=Inter');\n\nhtml {\n    scroll-behavior: smooth;\n}\n\nbody {\n    margin: 0;\n    color: var(--black-85);\n    font-family: 'Inter', sans-serif;\n    box-sizing: border-box;\n    letter-spacing: 0.02em;\n\n}\n\ndiv {\n    padding: 0;\n    border: 0;\n    margin: 0;\n\n    text-overflow: clip;\n    box-sizing: border-box;\n    background-clip: border-box;\n}\n\n:focus-visible {\n    outline: none;\n}\n\n::-webkit-scrollbar { \n    width: 7px;\n    height: 7px;\n}\n::-webkit-scrollbar-thumb { \n    background: var(--black-25);\n    border-radius: 5px;\n}\n::-webkit-scrollbar-thumb:hover {\n    filter: brightness(1.2);\n}\n::-webkit-scrollbar-corner {\n    background-color: #00000000;\n}\n\n:root {\n    --black_10:#040608;\n    --black-00:#101820;\n    --black-02: #171F27;\n    --black-03:#182027;\n    --black-05:#1c242b;\n    --black-07:#22282f;\n    --black-10:#282f36;\n    --black-15:#343b41;\n    --black-20:#40464d;\n    --black-25:#4c5258;\n    --black-30:#575d62;\n    --black-35:#64696e;\n    --black-45:#7c8084;\n    --black-65:#abaeb1;\n    --black-80:#cdcdce;\n    --black-85:#dbdcde;\n    --black-90:#e7e8e9;\n    --blue-1:#2c3a74;\n    --blue-2:#5a6ccd;\n    --hover-fg: var(--black-65);\n    --hover-bg: var(--black-15);\n    --red-1: #58292d;\n    --red-2: #B72828;\n    --red-3: #ec736a;\n    --green-1: #49c97c;\n    --dark-red: #28161c;\n}\n\n[data-sonner-toast] {\n    transition: height 200ms ease, box-shadow 200ms ease, opacity 200ms ease;\n}\n.toast {\n    font-size: 13px;\n    text-align: left;\n    display: flex;\n    align-items: center;\n    animation: toast-in 150ms ease;\n}\n@keyframes toast-in {\n    from { opacity: 0.5; }\n    to   { opacity: 1; }\n}\n.toast-icon {\n    font-size: 16px;\n    opacity: 0.6;\n}\n.toast-body {\n    margin-left: 8px;\n}\n.toast-label {\n    font-weight: 600;\n}\n.toast-verb {\n    opacity: 0.6;\n}\n.toast-note {\n    opacity: 0.4;\n    font-size: 12px;\n}\n.toast-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 11px;\n}\n.toast-header-label {\n    font-weight: 600;\n    opacity: 0.5;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n.toast-header-note {\n    opacity: 0.4;\n}\n.toast-divider {\n    border-bottom: 1px solid rgba(255,255,255,0.1);\n    padding-bottom: 6px;\n    margin-bottom: 6px;\n}\n.toast-row {\n    display: flex;\n    align-items: center;\n}\n\n.symbols {\n    font-family: 'Material Symbols Outlined';\n    user-select: none;\n}\n\n.mui-icons {\n    font-family: 'Material Icons';\n}\n\n.acticon { \n    border-radius: 4px;\n    font-size: 24px;\n\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    cursor: pointer;\n    user-select: none; \n}\n\n.acticon:hover {\n    filter: brightness(1.4);\n}\n\n.tridot {\n    font-size: 28px;\n    width: 24px;\n    line-height: 0.95;\n    cursor: pointer;\n    user-select: none; \n    font-family: 'Material Symbols Outlined';\n}\n\n.tridot:hover {\n    filter: brightness(1.3);\n}\n\n#wolfflogo {\n    position: absolute;\n    top: 16px;\n    left: 20px;\n}\n\n#session {\n    width: 200px;\n    height: 100%;\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n#friendly {\n    width: 180px;\n    height: 100%;\n    margin-right: 16px;\n\n    font-size: 15px;\n    border-radius: 4px;\n\n    background-color: var(--black-10);\n\n    display: flex;\n    text-align: left;\n    align-items: center;\n}\n\n#friendly.undefined {\n    background-color: var(--red-2);\n\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n#friendly.undefined.connected {\n    background-color: var(--green-1);\n}\n\n#friendly .name {\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 75%, transparent 100%);\n}\n\n#friendly.defined .name {\n    padding-left: 10px;\n}\n\n#friendly.defined .name::before {\n    font-family: 'Material Icons';\n    font-size: 13px;\n    color: var(--red-2);\n    content: 'circle';\n    padding-right: 6px;\n}\n\n#friendly.defined.connected .name::before {\n    color: var(--green-1);\n}\n\n#friendly .name.edit {\n    background-color: var(--black_10);\n    color: var(--black-90);\n    border: var(--black-90) solid 1px;\n    border-radius: 4px;\n    text-overflow: clip;\n}\n\n#chain-new,\n#device-new {\n    margin-left: 26px;\n}\n\n#device-new {\n    background-color: green;\n}\n\n#chain-new .symbol,\n#device-new .symbol {\n    font-size: 20px;\n}\n\n.symbol {\n    display: inline;\n    font-family: 'Material Symbols Outlined';\n    font-weight: 800;\n}\n\n#top-icons {\n    margin-left: 180px;\n    margin-top: 20px;\n    height: 32px;\n    max-height: 32px;\n    display: flex;\n    justify-content:space-between;\n    align-items: center;\n}\n\n.top.cta {\n    padding: 10px;\n    height: 100%;\n}\n\n#top-left, #top-right {\n    height: 32px;\n    max-height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n#top-right {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    justify-content:space-between;\n}\n\n/* Zoom hint placed between left and right clusters */\n#zoom-hint {\n    margin-left: 12px;\n    margin-right: auto; /* pull block toward the left cluster */\n    font-size: 13px;\n    color: var(--black-80);\n    opacity: 0.9;    \n    pointer-events: none;\n    min-width: 0; /* allow flex shrink/ellipsis */\n}\n\n#midi-over {\n    display: none;\n    position: absolute;\n    height: 100vh;\n    width: 100vw;\n    background-color: rgba(0,0,0,0.5);\n    z-index: 1;\n    backdrop-filter: blur(0.8px);\n}\n\n#midi {\n    font-size: 18px;\n    padding-right: 12px;\n    margin-right: 20px;\n    position: relative;\n    pointer-events: none;\n    filter: brightness(0.7);\n}\n\n#midi.enabled {\n    filter: brightness(1);\n    pointer-events: all;\n}\n\n#midi.enabled.selected {\n    filter: brightness(1.1);\n    outline: 2px solid var(--black-80);\n    z-index: 2;\n}\n\n#midi.midi-bad {\n    font-style: italic;\n    color: var(--black-65);\n}\n\n.midi-ports .port {\n    color: var(--black-65);\n}\n\n.midi-ports .port.selected {\n    color: var(--black-80);\n}\n\n.midi-ports .port.bad {\n    font-style: italic;\n    color: var(--black-45);\n}\n\n.midi-learn {\n    z-index: 2;\n    pointer-events: all;\n}\n\n.midi-learn.learning {\n    animation: pulse-fg 0.3s ease-in-out infinite;\n}\n\n@keyframes pulse-fg {\n    0%, 100% {\n        outline-width: 0.1px;\n        outline-color: rgba(147, 55, 255, 0);\n        filter: brightness(0.8);\n    }\n    50% {\n        outline-width: 3px;\n        outline-color: rgba(147, 55, 255, 0.5);\n        filter: brightness(1);\n    }\n}\n\n.midi-learn::after {\n    content: '';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 120cqw;\n    height: 120cqh;\n    background: rgb(147, 55, 255);\n    transform: translate(-50%, -50%);\n    animation: pulse-bg 1.5s ease-in-out infinite;\n    z-index: 2;\n}\n\n.midi-learn.learning::after {\n    animation: pulse-bg 0.3s ease-in-out infinite;\n}\n\n@keyframes pulse-bg {\n    0%, 100% {\n        opacity: 0;\n    }\n    50% {\n        opacity: 0.65;\n    }\n}\n\n#mute-all .symbol {\n    font-size: 20px;\n}\n\n#mute-all {\n    position: relative;\n    height: 32px;\n    width: 100px;\n    font-size: 18px;\n    background-color: var(--red-1);\n    margin-right: 20px;\n}\n\n#mute-all:hover {\n    background-color: var(--red-2);\n}\n\n#system-help {\n    width: 48px;\n    font-size: 26px;\n}\n\n#system-help a {\n    text-decoration: none;\n    color: var(--black-85);\n}\n\n#system-menu {\n    padding-right: 4px;\n    height: 32px;\n    width: 23px;\n    box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);\n\n    border-radius: 4px;\n\n    background: var(--black-02);\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    line-height: 1.3;\n\n    cursor: pointer;\n    user-select: none;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n#system-menu.update .tridot {\n    animation: system-menu 600s ease-in-out infinite;\n}\n\n@keyframes system-menu {\n    0%,0.25%,0.5% { transform: scale(1); }\n    0.125%,0.375% { transform: scale(1.4); }\n}\n\n#system-menu:hover {\n    filter: brightness(0.8);\n}\n\n#system-menu:hover .tridot {\n    filter: brightness(0.8);\n}\n\n#system-menu.update {\n    width: 100px;\n    justify-content: right;\n    background-color: var(--blue-1);\n}\n\n#system-menu.update .text {\n    font-size: 17px;\n}\n\n/* soft, sweeping highlight */\n.shimmer {\n    position: relative;\n    overflow: hidden;\n    background-color: #1F2937;\n    color: #D1D5DB;\n}\n\n.shimmer::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -120%; /* Start off-screen */\n    width: 50%;\n    height: 100%;\n    background: linear-gradient(\n        90deg,\n        transparent,\n        rgba(255, 255, 255, 0.14), /* faint white highlight */\n        transparent\n    );\n    transform: skewX(-25deg); /* Skews the light source for a more dynamic look */\n    animation: shimmer 600s ease-in-out infinite;\n}\n\n@keyframes shimmer {\n    0%,1%,2%,100% { left: -120%; }\n    0.5%,1.5% { left: 120%; }\n}\n\n#space {\n    position: fixed;\n    top: 70px;\n    left: 380px;\n    height: calc(100vh - 72px - 5px);\n    width: calc(100vw - 360px - 30px);\n    overflow: hidden;\n}\n\n/* User background image layer — sits behind all chain content, never the\n   sidebar (it lives inside #space, which already starts past the browser).\n   Driven by --space-bg-* custom properties set on #space from app settings. */\n.space-bg {\n    position: absolute;\n    inset: 0;\n    z-index: 0;                       /* painted before later, auto-z chain content */\n    pointer-events: none;\n    background-image: var(--space-bg-image, none);\n    background-size: var(--space-bg-size, cover);\n    background-repeat: var(--space-bg-repeat, no-repeat);\n    background-position: var(--space-bg-pos, center);\n    opacity: var(--space-bg-opacity, 1);\n    filter: blur(var(--space-bg-blur, 0px));\n}\n\n/* Dim scrim above the image so busy photos don't drown the UI */\n.space-bg::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, var(--space-bg-dim, 0));\n}\n\n#space.midi-learning {\n    z-index: 1;\n}\n\n.menu {\n    position: absolute;\n    z-index: 100;\n    border-radius: 2px;\n    background: var(--black-07);\n    padding: 6px 6px 6px 6px;\n    width: 160px;\n}\n  \n.menu .item  {\n    position: relative;\n    height: 32px;\n    padding-left: 10px;\n    color: var(--black-80);\n    cursor: pointer;\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 160px;\n}\n\n.menu .item.submenu {\n    height: 38px;\n    padding-top: 4px;\n}\n  \n.menu .item.divider {\n    border-top: 1px solid var(--black-30);\n}\n\n.menu .item:hover {\n    color: var(--black-90);\n    background: var(--hover-bg);\n}\n\n.menu .item.submenu::after {\n    content: '>';\n    position: absolute;\n    right: 10px;\n    font-size: 16px;\n    color: var(--black-90);\n}\n\n.menu .item .submenu  {\n    display: none;\n    position: absolute;\n    z-index: 100;\n    top: 0px;\n    left: -174px;\n    border-radius: 4px;\n    background: var(--black-07);\n    padding: 3px 8px 6px 8px;\n}\n\n.menu .item .submenu .item .submenu  {\n    display: none;\n    position: absolute;\n    z-index: 100;\n    top: 0px;\n    left: -100px;\n    border-radius: 4px;\n    background: var(--black-07);\n    padding: 3px 8px 6px 8px;\n}\n\n.menu .item:hover .submenu  {\n    display: block;\n}\n\n.menu .item .submenu .item:hover .submenu   {\n    display: block;\n}\n\n.menu .submenu .item {\n    color: var(--black-65);\n}\n\n.menu .submenu .item:hover {\n    color: var(--black-90);\n}\n\n.menu .item .choice  {\n    padding-right: 8px;\n}\n\n.menu .item .owner {\n    color: var(--black-45);\n}\n\n.menu .item.hilite .choice {\n    color: var(--black-90);\n}\n\n.hidden { display: none; }\n\n#ingest-errors {\n    position: fixed;\n    z-index: 999;\n    width: 90vw;\n    height: 50vh;\n    top: 25vh;\n    height: 50vh;\n    left: 5vw;\n    border-radius: 5px;\n    background: white;\n    color: black;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  }\n  \n  #ingest-errors pre {\n    padding-left: 10px;\n    height: 40vh;\n    font-size: 17px;\n    color: black;\n    overflow: scroll;\n  }\n  \n  #ingest-errors button {\n    display: flex;\n    color: black;\n    justify-content: center;\n    align-items: center;\n    font-size: 18px;\n    width: 80px;\n  }\n\n#screen {\n    height: 100vh;\n    width: 100vw;\n    min-width: 1036px;\n    background: var(--black-00);\n    position: relative;\n    overflow: hidden;\n}\n\n#screen.disconnected {\n    background: var(--dark-red);\n}\n  \n.midi-channel.selected .reserved {\n    padding-left: 10px;\n    opacity: 60%;\n    width: 100%;\n}\n\n.note.selected .reserved {\n    padding-left: 10px;\n    color: var(--black-80);\n    width: 100%;\n}\n\n.browser-device {\n    position: relative;\n    width: 325px;\n    height: 40px;\n    display: flex;\n    background-color: var(--black-15);\n    align-items: center;\n    color: var(--black-80);\n    border: 1px solid #00000000;\n}\n\n.browser-device:hover {\n    color: var(--black-90);\n    border-color: var(--black-35);\n}\n\n.browser-device.selected {\n    border-color: var(--black-45);\n}\n\n.browser-device .name {\n    position: absolute;\n    left: 10px;\n    width: 100%;\n\n    font-size: 15px;\n    font-weight: 500;\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 75%, transparent 100%);\n}\n\n.browser-device.selected .name {\n    color: var(--black-90);\n    font-weight: bold;\n}\n\n.browser-device .popup {\n    position: absolute;\n    top: 8px;\n    right: 1%;\n\n    font-size: 24px;\n}\n\n.browser-module {\n    border-radius: 2px;\n    position: relative;\n    height: 40px;\n    width: 328px;\n\n    display: flex;\n    background-color: var(--black-15);\n\n    align-items: center;\n}\n\n.browser-module.invalid {\n    background: var(--red-1);\n}\n\n.browser-module .popup {\n    font-size: 24px;\n    position: absolute;\n    top: 8px;\n    right: 3px;\n}\n\n.popup-menu .menu-list .menu-item.octave {\n    display: block; \n    text-align: right; \n}\n\n.browser-module.submodule {\n    background-color: var(--black-10);\n}\n\n.browser-module .expander {\n    position: absolute;\n    right: 83px;\n    width: 18px;\n\n    color: var(--black-65);\n\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    cursor: pointer;\n    user-select: none; \n}\n\n.browser-module.invalid .expander {\n    color: var(--black-45);\n}\n\n.browser-module .device  {\n    position: relative;\n    left: 12px;\n    top: -8px;\n    width: 260px;\n\n    font-size: 14px;\n    color: var(--black-90);\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 80%, transparent 100%);\n}\n\n.browser-module.invalid .device  {\n    color: var(--black-45);\n    font-style: italic;\n}\n\n.browser-module.stereo .device {\n    width: 210px;\n}\n\n.browser-module.m2s .device  {\n    width: 230px;\n}\n\n.browser-module .name {\n    position: absolute;\n    bottom: 3px;\n    left: 12px;\n    width: 260px;\n\n    font-size: 12px;\n    color: var(--black-65);\n\n    white-space: nowrap;\n    overflow: hidden;\n    mask: linear-gradient(to right, black 80%, transparent 100%);\n}\n\n.browser-module.invalid .name {\n    color: var(--black-45);\n    font-style: italic;\n}\n\n.browser-module.stereo .name {\n    width: 210px;\n}\n\n.browser-module.m2s .name {\n    width: 240px;\n}\n\n.browser-module .channels {\n    position: absolute;\n    right: 24px;\n    height: 100%;\n\n    font-size: 11px;\n\n    white-space: nowrap;\n    text-overflow: clip;\n\n    text-align: center;\n    display: flex;\n    justify-content: right;\n    align-items: center;\n}\n\n.browser-module .channels .channel {\n    height: 26px;\n    width: 26px;\n\n    font-weight: normal;\n\n    border-radius: 26px;\n    color: var(--black-80);\n    background-color: var(--black-25);\n\n    box-shadow: 0 0 1px var(--black-05);\n\n    font-size: 13px;\n\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.browser-module.invalid .channels .channel {\n    color: var(--black-45);\n}\n\n.browser-module .channels .channel.used {\n    color: var(--black-05);\n    font-weight: 500;\n}\n\n.browser-module .channels .channel.m2s {\n    position: relative;\n    width: 42px;\n    font-size: 12.5px;\n}\n\n.browser-module .channels .channel.stereo.L {\n    margin-right: 3px;\n}\n\n/* DOUBLE-CLICK an L/R chip to add just that channel */\n.browser-module .channels .channel.choosable {\n    cursor: pointer;\n}\n\n.browser-module .inuse {\n    position: absolute;\n    left: 306px;\n    width: 51px;\n    height: 24px;\n    font-size: 0px;\n\n    display: flex;\n\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n\n    visibility: hidden;\n}\n\n.browser-module.used .inuse {\n    font-size: 13px;\n    font-weight: bold;\n\n    visibility:visible;\n}\n\n.browser-module .popup {\n    font-size: 22px;\n    color: var(--black-65);\n}\n\n#browser-main {\n    width: 360px;\n    align-content: start;\n    top: 70px;\n    position: absolute;\n    left:20px;\n    background-color: var(--black-05);\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n    height: 42px;\n    overflow-x: visible;\n}\n\n#browser-main .types {\n    padding-top: 12px;\n\n    color: var(--black-45);\n\n    display:flex;\n    gap: 32px;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n#browser-main .types .choice .svgicon {\n    display:flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n    padding-right: 4px;\n}\n\n#browser-main .types .choice {\n    font-size: 16px;\n    font-weight: 500;\n\n    cursor: pointer;\n    user-select: none; \n\n    display:flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n#browser-main .types .choice .symbols {\n    font-size: 20px;\n    padding-right: 3px;\n    vertical-align: middle;\n}\n\n#browser-main .types .choice:hover {\n    color: var(--black-80);\n}\n\n#browser-main .types .choice.selected {\n    color: var(--black-85);\n}\n\n#browser-main .types .choice .svgicon .fill {\n    fill: var(--black-45);\n}\n\n#browser-main .types .choice:hover .svgicon .fill {\n    fill: var(--black-80);\n}\n\n#browser-main .types .choice.selected .svgicon .fill  {\n    fill: var(--black-85);\n}\n\n#browser {\n    width: 360px;\n    align-content: start;\n    top: 112px;\n    position: absolute;\n    left:20px;\n    background-color: var(--black-05);\n    height: calc(100vh - 116px - 5px);\n    overflow-x: visible;\n}\n\n.browser {\n    position: relative;\n    display:flex;\n    flex-direction: column;\n    background-color: var(--black-30);\n    align-items: center;\n    overflow: visible;\n}\n\n.browser .search-hr {\n    width: 328px;\n    height: 1px;\n    margin-bottom: 14px;\n}\n\n.browser .tag-hr {\n    width: 328px;\n    height: 1px;\n    background-color: var(--black-25);\n    margin-top: 8px;\n    margin-bottom: 8px;\n}\n\n.browser .search .icon {\n    position: absolute;\n    top: 6px;\n    left: 26px;\n    font-size: 22px;\n    color: var(--black-45);\n    user-select: none; \n}\n\n.browser .searchbox {\n    margin-top: 4px;\n    font-size: 15px;\n  \n    width: 328px;\n    height: 32px;\n    /** if missing, caret appears in upper left of searchbox when empty (and focused) */\n    padding: 5px;\n    padding-left: 38px;\n\n    color: var(--black-65);\n    background-color: var(--black-10);\n\n    border: solid var(--black-15) 1px;\n    border-radius: 4px;\n\n    /** prevents default outlining of active input text box */\n    outline: none;\n\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    text-align: left;\n    overflow: hidden;\n}\n\n.browser .searchbox.hidden {\n    display: none;\n}\n  \n.browser .searchbox.empty {\n    color: var(--black-35);\n    user-select: none; \n}\n\n.browser .searchbox.edit {\n    font-style: normal;\n    text-overflow: clip;\n    overflow: hidden;\n    color: var(--black-80);\n    background-color: var(--black-20);\n}\n\n.browser.module .types {\n    color: var(--black-45);\n\n    margin-top: 14px;\n    margin-bottom: 0px;\n\n    height: 100%;\n    max-height: 24px;\n\n    display: flex;\n    align-items: center;\n    gap: 18px;\n}\n\n.browser .types .choice {\n    font-size: 15px;\n    letter-spacing: 0;\n\n    cursor: pointer;\n    user-select: none; \n\n    display:flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n.browser .types .choice:hover {\n    color: var(--black-80);\n}\n\n.browser .types .choice.selected {\n    color: var(--black-85);\n}\n\n.browser .types .choice .svgicon {\n    display:flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n.browser .types .choice .svgicon .fill {\n    fill: var(--black-45);\n}\n\n.browser .types .choice:hover .svgicon .fill {\n    fill: var(--black-80);\n}\n\n.browser .types .choice.selected .svgicon .fill  {\n    fill: var(--black-85);\n}\n\n.browser .filters {\n    width: 336px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n    margin-top: 15px;\n    margin-bottom: 4px;\n}\n\n.browser .tags .tag:not(.selected):hover {\n    color: var(--black-03);\n    background-color: var(--black-45);\n}\n\n.browser .header .type {\n    position: absolute;\n    left: 5px;\n\n    font-size: 18px;\n    font-weight: bold;\n    color: var(--black-85);\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n\n    user-select: none; \n}\n\n.browser .header .sort,\n.browser .header .active {\n    width: 75px;\n    height: 22px;\n    border-radius: 4px;\n\n    font-size: 13px;\n    font-weight: bold;\n\n    padding-left: 12px;\n    padding-right: 10px;\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n\n    cursor: pointer;\n    user-select: none; \n\n    color: var(--black-05);\n    background-color: var(--black-80);\n}\n\n.browser .header .sort:hover,\n.browser .header .active:hover {\n    color: var(--black-05);\n    background-color: var(--black-65);\n}\n\n.browser .header {\n    width: 320px;\n    margin-bottom: 8px;\n\n    font-size: 22px;\n\n    display: flex;\n    text-align: center;\n    justify-content:space-between;\n    align-items: center;\n}\n\n.browser .header > .left {\n    display: flex;\n    text-align: center;\n    justify-content: left;\n    align-items: center\n}\n\n.browser .header > .right {\n    display: flex;\n    text-align: center;\n    justify-content: left;\n    align-items: center;\n}\n\n.chain.browser .header .fave {\n    margin-left: 10px;\n    height: 22px;\n    color: var(--black-35);\n}\n\n.chain.browser .header .fave.selected {\n    color: var(--black-80);\n}\n\n.chain.browser .header .fave:hover {\n    color: var(--black-65);\n}\n\n.chain.browser .header .normal {\n    font-size: 23px;\n    height: 22px;\n    margin-left: 13px;\n    color: var(--black-35);\n}\n\n.chain.browser .header .normal.selected {\n    color: var(--black-80);\n    font-weight: bold;\n}\n\n.chain.browser .header .normal:hover {\n    color: var(--black-65);\n}\n\n.browser .results {\n    position: relative;\n    flex-grow: 1;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    width: 332px;\n    margin-left: 10px;\n}\n\n.browser .results .items {\n    width: 340px;\n}\n\n.browser .results .items .item {\n    min-height: 43px;\n    padding: 1px;\n}\n\n.browser.device .results .items .item:nth-child(odd) .browser-device {\n    background-color: var(--black-20);\n}\n\n.browser .results .items .item .subitem  {\n    min-height: 42px;\n    display: none;\n}\n\n.browser .results .items .item .subitem.expanded {\n    display: block;\n}\n\n.browser .results .items .item .subitem.expanded.top {\n    margin-top: 2px;\n}\n\n.browser .results .items .empty {\n    height: 42px;\n    padding-right: 40px;\n\n    font-size: 14px;\n    font-style: italic;\n    color: var(--black-45);\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n\n    user-select: none; \n}\n\n.browser.device > .cta.new {\n    left: 21px;\n}\n\n#controls {\n    display: flex;\n    gap: 14px;\n    top: 10px;\n    position: absolute;\n    left:506px;\n}\n\n.cta {\n    height: 32px;\n    padding-left: 16px;\n    padding-right: 16px;\n    border-radius:4px;\n    background-color: var(--blue-1);\n\n    box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.3);\n\n    font-size: 14px;\n    font-weight: 500;\n    color: var(--black-80);\n\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    cursor: pointer;\n    user-select: none; \n\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.cta:hover {\n    color: var(--black-65);\n}\n\n.cta.secondary {\n    color: var(--blue-2);\n    outline: 1px solid var(--blue-2);\n    outline-offset: -1px;\n    background-color: transparent;\n}\n\n.cta.secondary:hover {\n    color: var(--black-65);\n}\n\n.modal.modtype .options {\n    display: flex;\n    gap: 22px;\n    justify-content: space-around;\n    padding-left: 22px;\n    padding-right: 22px;\n    padding-top: 20px;\n}\n\n.modal.modtype .options .option {\n    font-size: 48px;\n    height: 130px;\n    padding-left: 20px;\n    padding-right: 20px;\n    border-radius: 4px;\n    background-color: var(--black-15);\n\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    cursor: pointer;\n    user-select: none; \n}\n\n.popup {\n    user-select: none; \n    cursor: pointer;\n}\n\n.popup-menu {\n    visibility: hidden;\n    position: absolute;\n    border: 1px solid #333;\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);\n    transition: opacity 0.2s ease-in-out;\n    background-color: #00000000;\n}\n\n.popup-menu:hover {\n    display: block;\n}\n  \n.menu-list,\n.submenu-list {\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 500;\n    list-style: none;\n    margin-top: 5px;\n    padding-top: 2px;\n    padding-bottom: 2px;\n    padding-left: 5px;\n    padding-right: 5px;\n    background-color: var(--black-00);\n    border: 1px solid var(--black-10);\n}\n\n.menu-item {\n    position: relative;\n    padding-left: 8px;\n    padding-right: 8px;\n    padding-top: 7px;\n    padding-bottom: 7px;\n\n    color: var(--black-80);\n    font-weight: 500;\n\n    cursor: pointer;\n    user-select: none;;\n    white-space: nowrap;\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n/* invisible hover zones extending from parent menu items */\n.menu-item.cascade::before {\n    content: '';\n    position: absolute;\n    top: -8px;\n    bottom: -8px;\n    left: -8px;\n    right: -15px; /* Extend further right toward submenu */\n    z-index: -1;\n    pointer-events: auto;\n  }\n\n  .submenu-list::before {\n    content: '';\n    position: absolute;\n    top: -8px;\n    bottom: -8px;\n    left: -15px; /* Connect back to parent menu */\n    right: -8px;\n    z-index: -1;\n    pointer-events: auto;\n  }\n\n  /* Increase hit area for cascade items */\n  .submenu-list {\n    padding-left: 5px;\n    padding-right: 4px;\n  }\n\n  /* Create invisible connection between submenu and parent */\n.menu-list::after,\n  .submenu-list::after {\n    content: '';\n    position: absolute;\n    top: -20px;\n    bottom: 0;\n    left: -10px; /* Invisible bridge from parent */\n    width: 20px;\n    pointer-events: auto;\n    z-index: 1;\n  }\n\n.menu-item.midi {\n    justify-content: left;\n    padding-top: 6px;\n    padding-bottom: 6px;\n    color: var(--black-65);\n}\n\n.menu-item.midi .svgicon {\n    padding-top: 4px;\n}\n\n.menu-item.disabled {\n    color: var(--black-45);\n    font-weight: normal;\n}\n  \n.menu-item.shimmer {\n    background-color: var(--black-10);\n    border-radius: 4px;\n    color: #7db4f0;\n}\n\n.menu-item.active:hover {\n    background: var(--black-20);\n}\n\n.menu-item.cascade:hover {\n    background: var(--black-20);\n}\n\n.menu-item.div-top {\n    border-top: 1px solid var(--black-30);\n}\n\n.menu-item.div-bottom {\n    border-bottom: 1px solid var(--black-30);\n}\n  \n.menu-item:has(+ .div-top) {\n    padding-top: 10px;\n    padding-bottom: 11px;\n}\n\n.menu-item.cascade::after {\n    position: relative;\n    right: -4px;\n    font-family: 'Material Symbols Outlined';\n    font-size: 11px;\n    font-weight: bold;\n    content: \"arrow_forward_ios\";\n    margin-right: 0px;\n    color: var(--black-90);\n}\n\n.menu-item.cascade.empty::after {\n    color: var(--black-45);\n}\n\n.menu-item.cascade.disabled::after {\n    color: var(--black-45);\n}\n\n.menu-item.cascade.empty {\n    color: var(--black-45);\n}\n\n.submenu-list {\n    position: absolute;\n    visibility: hidden;\n    box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.3);\n    margin-left: 5px;\n    z-index: 1000;\n}\n  \n.menu-item:hover > .submenu-list {\n    min-width: 40px;\n    visibility: visible;\n}\n\n.newmod .name.editbox {\n    font-size: 18px;\n    height: 28px\n}\n\n.modal .newmod .prompt {\n    color: var(--black-65);\n    font-size: 20px;\n}\n\n.modal .newmod .header {\n    font-size: 16px;\n    color: var(--black-65);\n}\n\n.modal .newmod .options {\n    padding: 10px;\n    background-color: var(--black-05);\n}\n\n.modal .newmod .option.selected {\n    background-color: var(--black-15);\n    color: var(--black-90);\n}\n\n.modal .newmod .cta.disabled {\n    background-color: var(--black-15);\n    color: var(--black-30);\n}\n\n.modal .newmod .option.disabled{\n    color: var(--black-35);\n}\n\n.modal .newmod .option:hover {\n    background-color: var(--black-25);\n}\n\n.midi-event {\n    z-index: 10;\n    border-radius: 32px;\n    visibility: hidden;\n    border: 5px solid var(--black-45);\n\n    font-weight: 500;\n    color: var(--black-80);\n\n    background-color: rgb(0 0 0 / 0.6);\n\n    position: absolute;\n    width: 250px;\n    height: 250px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n\n    animation: fadeOut 1.2s ease-in;\n\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n\n    pointer-events: none;\n}\n\n.midi-event .note {\n    font-size: 100px;\n    height: 100px;\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n.midi-event .channel {\n    font-size: 38px;\n    height: 40px;\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n.midi-event .state {\n    font-size: 42px;\n    height: 60px;\n\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    align-items: center;\n}\n\n.midi-event .ts {\n    font-size: 8px;\n    color: var(--black-45);\n}\n\n.midi-event::after {\n    position: absolute;\n    font-weight: normal;\n    opacity: 0.3;\n    font-family: 'Material Icons';\n    font-size: 250px;\n    content: 'music_note';\n    color: var(--black-65);\n}\n\n@keyframes fadeOut {\n    from { \n      visibility: visible; \n      opacity: 0.9;\n    }\n    to { \n      visibility: hidden; \n      opacity: 0; \n    }\n}  \n\n#time-display {\n    z-index: 999;\n    font-size: 14px;\n    color: #444;\n    position: fixed;\n    background-color: #00000000;\n    user-select: none;    \n    left: 18px;\n    top: 55px;\n}\n\n\n/* On narrower screens, show hint on its own top row */\n@media (max-width: 1200px) {\n    #top-icons { height: auto; max-height: none; flex-wrap: wrap; align-items: flex-start; }\n    #zoom-hint {\n        order: -1;\n        flex: 0 0 100%;\n        margin: 0 0 8px 0;\n        padding: 4px 0;\n        text-align: center;\n        background: var(--dark-red);\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        border-radius: 4px;\n    } \n    #browser-main {top: 100px}\n    #browser {top: 140px}\n    #space {top: 100px}\n    #time-display {\n        width: 155px;\n    }\n}\n\n/* ── NODE PICKER (right-click replace) ── */\n.node-picker {\n    width: 280px;\n    max-height: 60vh;\n    display: flex;\n    flex-direction: column;\n    background-color: var(--black-00);\n    border: 1px solid var(--black-15);\n    border-radius: 6px;\n    box-shadow: 2px 4px 12px rgba(0, 0, 0, 0.4);\n    overflow: hidden;\n}\n\n.node-picker .np-filter {\n    flex: 0 0 auto;\n    margin: 6px;\n    padding: 7px 9px;\n    font-size: 13px;\n    color: var(--black-90);\n    background-color: var(--black-10);\n    border: 1px solid var(--black-20);\n    border-radius: 4px;\n    outline: none;\n}\n\n.node-picker .np-filter:focus {\n    border-color: #4a90d9;\n}\n\n.node-picker .np-tags {\n    flex: 0 0 auto;\n    padding: 2px 8px 8px;\n    max-height: 96px;\n    overflow-y: auto;\n    border-bottom: 1px solid var(--black-10);\n}\n\n.node-picker .np-tags .tag {\n    cursor: pointer;\n    height: 20px;\n}\n\n.node-picker .np-list {\n    flex: 1 1 auto;\n    min-height: 0;\n    overflow-y: auto;\n    padding: 0 6px 6px;\n}\n\n.node-picker .np-section {\n    font-size: 10px;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--black-45);\n    padding: 6px 4px 2px;\n}\n\n/* CURRENT slot occupant, pinned at the top and bracketed by two divider lines */\n.node-picker .np-pinned {\n    border-top: 1px solid var(--black-20);\n    border-bottom: 1px solid var(--black-20);\n    margin-bottom: 4px;\n}\n\n.node-picker .np-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 6px;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.node-picker .np-row:hover {\n    background-color: var(--black-10);\n}\n\n.node-picker .np-row .device {\n    flex: 1 1 auto;\n    font-size: 13px;\n    color: var(--black-90);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.node-picker .np-row .name {\n    flex: 0 0 auto;\n    font-size: 11px;\n    color: var(--black-60);\n    white-space: nowrap;\n}\n\n/* CHANNEL circles — scaled-down version of .browser-module .channels .channel */\n.node-picker .np-row .channels {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: right;\n}\n\n.node-picker .np-row .channels .channel {\n    height: 18px;\n    width: 18px;\n    border-radius: 18px;\n    background-color: var(--black-25);\n    color: var(--black-80);\n    box-shadow: 0 0 1px var(--black-05);\n    font-size: 9.5px;\n    font-weight: normal;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.node-picker .np-row .channels .channel.used {\n    color: var(--black-05);\n    font-weight: 500;\n}\n\n.node-picker .np-row .channels .channel.m2s {\n    width: 29px;\n    font-size: 9px;\n}\n\n.node-picker .np-row .channels .channel.stereo.L {\n    margin-right: 2px;\n}\n\n.node-picker .np-row.current .device::before {\n    content: '\\25CF\\00a0';\n    color: var(--black-50);\n}\n\n.node-picker .np-empty {\n    padding: 12px;\n    text-align: center;\n    color: var(--black-45);\n    font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
